// socket.js - ENHANCED VERSION WITH DEBUG LOGGING
import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_API_URL ||
  "https://api.luckytarget.in";

// Debug logging utility
const socketLogger = (type, message, data = {}) => {
  // Logger disabled to keep console clean
};

// Get token safely
const getToken = () => {
  if (typeof window === "undefined") return null;
  try {
    const authRaw = localStorage.getItem("authUser");
    if (authRaw) {
      const auth = JSON.parse(authRaw);
      const token = auth?.token || null;
      socketLogger('debug', 'Token retrieved', { hasToken: !!token, userId: auth?.user?._id || auth?._id });
      return token;
    }
  } catch (error) {
    socketLogger('error', 'Error getting auth token', { error: error.message });
  }
  return null;
};

// Create socket instance with better configuration
export const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"],
  withCredentials: true,
  auth: {
    token: getToken()
  },
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  forceNew: false,
  autoConnect: false
});

// Enhanced socket event listeners for connection management
socket.on("connect", () => {
  // Re-join any necessary rooms after reconnection
  const authRaw = localStorage.getItem("authUser");
  if (authRaw) {
    try {
      const auth = JSON.parse(authRaw);
      const userId = auth?.user?._id || auth?._id;
      if (userId) {
        socket.emit("joinUser", { userId });
      }
    } catch (error) {
      console.error('Error rejoining user room', error);
    }
  }
});

// Original socket instance settings
export { socketLogger };